module.exports = __webpack_public_path__ + "img/list_select.5056e93b.svg";